<template>
  <div class="sidebar-filters">
    <b-button class="text-uppercase" ref="escape" variant="reset-all" @click.prevent="resetFilters()">
      <i class="fas fa-eraser" /> {{ 'Reset all filters' | translate }}
    </b-button>
    <task-select-filter
      :title="$t('Filter by macro')"
      icon="fas fa-layer-group"
      :options="macroFilterOptions"
      @edit="onEditFilter($event, 'filter__category')"
      @clean="cleanComponentFilters(['filter__category'])"
    />
    <task-select-filter
      :title="$t('Filter by priority')"
      icon="fas fa-flag"
      :options="priorityFilterOptions"
      @edit="onEditFilter($event, 'filter__priority')"
      @clean="cleanComponentFilters(['filter__priority'])"
    />
    <task-select-filter
      :title="$t('Filter by state')"
      icon="far fa-circle"
      :options="stateFilterOptions"
      @edit="onEditFilter($event, 'filter__state')"
      @clean="cleanComponentFilters(['filter__state'])"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { TYPES as TASK_TYPES } from './store'
import { TYPES as TASK_CATEGORY_TYPES } from '../task-category/store'
import { TYPES as TASK_PRIORITY_TYPES } from '../task-priority/store'
import { TYPES as TASK_STATE_TYPES } from '../task-state/store'
import CommonFiltersMixin from '@/pages/common-filters/CommonFiltersMixin'
import TaskSelectFilter from './components/filters/TaskSelectFilter.vue'

const mapToOptions = (listState) => {
  const results = (listState && listState.results) || []
  return results
    .filter((item) => item.status !== 0)
    .map((item) => ({ id: item.id, label: item.name }))
}

export default {
  name: 'TaskHistoryCommonFilters',
  mixins: [CommonFiltersMixin],
  components: {
    'task-select-filter': TaskSelectFilter
  },
  props: {
    categoryTypeCode: { type: String, default: 'company' }
  },
  computed: {
    ...mapGetters({
      filters: TASK_TYPES.GENERIC.task.task.LIST.GETTERS.filters,
      taskCategoryList: TASK_CATEGORY_TYPES.GENERIC.task['task-category'].LIST.GETTERS.list,
      taskPriorityList: TASK_PRIORITY_TYPES.GENERIC.task['task-priority'].LIST.GETTERS.list,
      taskStateList: TASK_STATE_TYPES.GENERIC.task['task-state'].LIST.GETTERS.list
    }),
    macroFilterOptions () {
      return mapToOptions(this.taskCategoryList)
    },
    priorityFilterOptions () {
      return mapToOptions(this.taskPriorityList)
    },
    stateFilterOptions () {
      return mapToOptions(this.taskStateList)
    }
  },
  created () {
    this.fetchCategoryList({ filter__status: 1, filter__type__code: this.categoryTypeCode })
    this.fetchPriorityList({ filter__status: 1 })
    this.fetchStateList({ filter__status: 1 })
  },
  watch: {
    categoryTypeCode: {
      handler (val) {
        this.fetchCategoryList({ filter__status: 1, filter__type__code: val || 'company' })
      }
    }
  },
  methods: {
    ...mapActions({
      ...TASK_TYPES.GENERIC.task.task.LIST.ACTIONS,
      storeSetFilters: TASK_TYPES.GENERIC.task.task.LIST.ACTIONS.setFilters,
      fetchCategoryList: TASK_CATEGORY_TYPES.GENERIC.task['task-category'].LIST.ACTIONS.setFilters,
      fetchPriorityList: TASK_PRIORITY_TYPES.GENERIC.task['task-priority'].LIST.ACTIONS.setFilters,
      fetchStateList: TASK_STATE_TYPES.GENERIC.task['task-state'].LIST.ACTIONS.setFilters
    }),
    setFilters (filters) {
      const next = Object.assign({}, filters || {})
      if (next.filter__state != null) {
        delete next.filter__state__is_final
      } else {
        next.filter__state__is_final = 'False'
      }
      return this.storeSetFilters(next)
    },
    onEditFilter (filterList, filterName) {
      this.editComponentFilters(filterList, filterName)
    },
    cleanComponentFilters (componentFilters) {
      const next = Object.assign({}, this.filters)
      const toRemove = Array.isArray(componentFilters) ? componentFilters : [componentFilters]
      toRemove.forEach((k) => { delete next[k] })
      return this.setFilters(next)
    }
  }
}
</script>
